import { POLICY_AUTOMATIC, POLICY_STATUS } from "@app/types/policy";

export const POLICY_STATUS_FILTER_OPTIONS = [
    { label: "Active", value: POLICY_STATUS.Active },
    { label: "Deactivated", value: POLICY_STATUS.Deactivated },
];

export const POLICY_AUTOMATIC_FILTER_OPTIONS = [
    { label: "Yes", value: POLICY_AUTOMATIC.Yes },
    { label: "No", value: POLICY_AUTOMATIC.No },
];
